// src/app-globals/index.ts
var globalScripts = (
  /* default */
  () => {
  }
);
var globalStyles = (
  /* default */
  ""
);
export {
  globalScripts,
  globalStyles
};
